<template>
  <div class="press-romm-inner" :class="{ 'in-viewport': animate }">
    <div class="bg-secondary press-room-inner">
      <Breadcrumbs />
      <div class="container img-pos ">
        <div class="main-img">
          <picture>
            <source
              class="img-absolute br-12"
              media="(max-width: 767px)"
              :srcset="
                _.get(
                  contentData,
                  'data.list[0].cover_image.[0].devices.mobile'
                )
              "
            />
            <source
              class="img-absolute br-12"
              media="(max-width: 1023px)"
              :srcset="
                _.get(
                  contentData,
                  'data.list[0].cover_image.[0].devices.tablet'
                )
              "
            />
            <img
              class="img-absolute br-12"
              :src="
                _.get(
                  contentData,
                  'data.list[0].cover_image.[0].devices.desktop'
                )
              "
              alt
            />
          </picture>
        </div>
      </div>
    </div>
    <div class="news-content container">
      <div class="date font-16 tbc-medium">
        {{ date }}
      </div>
      <h1 class="font-38 tbc-light lh-57 uppercase">
        {{ _.get(contentData, "data.list[0].title") }}
      </h1>
      <div
        class="text font-18 lh-24 tbc-medium"
        v-html="_.get(contentData, 'data.list[0].content')"
      ></div>
    </div>

    <InnerGallery :contentData="innerGalleryData" />

    <ShareTags :data="_.get(contentData, 'data.list[0].tags')" />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs";
import InnerGallery from "./InnerGallery";
import ShareTags from "../ShareTags";
import moment from "moment";

export default {
  props: ["contentData", "evenOdd"],
  data() {
    return {
      animate: false
    };
  },
  components: {
    Breadcrumbs,
    InnerGallery,
    ShareTags
  },
  computed: {
    date() {
      return moment(_.get(this.contentData, "data.list[0].date")).format(
        "D MMM, YYYY"
      );
    },
    innerGalleryData() {
      let arr = [];
      let newArrayOfObj = _.get(this.contentData, "data.list");
      newArrayOfObj = newArrayOfObj
        ? newArrayOfObj.map(({ images: additional_images, ...rest }) => ({
            additional_images,
            ...rest
          }))
        : [];
      // console.log(newArrayOfObj, "newArrayOfObj");

      return { data: { list: newArrayOfObj } };
    }
  },
  mounted() {
    this.$store.commit("main/setState", { key: "hideBreadcrumb", val: true });
    this.$store.commit("main/setState", { key: "isInner", val: true });
    setTimeout(() => {
      this.animate = true;
    }, 800);
  },
  beforeDestroy() {
    this.$store.commit("main/setState", { key: "isInner", val: false });
    this.$store.commit("main/setState", { key: "hideBreadcrumb", val: false });
  }
};
</script>

<style scoped>
.press-romm-inner {
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: 0.6s ease;
}
.press-romm-inner.in-viewport {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
}

.press-room-inner >>> .breadcrumb-cont {
  top: 20px;
}
.bg-secondary {
  margin-top: 0;
}
.img-pos {
  transform: translateY(69px);
}
.news-content {
  padding-top: 55px;
}
.main-img {
  position: relative;
  padding-top: 40.45%;
  margin-bottom: 87px;
}
.date {
  color: #00a3e0;
  margin-bottom: 16.5px;
}
h1 {
  color: var(--secondary);
  margin-bottom: 55px;
}
.text {
  color: var(--text-gray);
  margin-bottom: 26px;
}
.website {
  margin-bottom: 53px;
}
.website a {
  color: var(--tbc-blue);
  /* text-decoration: underline; */
}
.breadcrumbs {
  margin-bottom: 55px;
}
@media screen and (max-width: 1023px) {
  .main-img {
    padding-top: 40%;
  }
  .breadcrumbs {
    margin-bottom: 34px;
  }
  .news-content .font-38 {
    font-size: 21px;
  }
}
@media screen and (max-width: 767px) {
  .breadcrumbs {
    margin-bottom: 30px;
  }
  .main-img {
    padding-top: 42%;
    margin-bottom: 74px;
  }
  .date {
    margin-bottom: 21px;
  }
  .text {
    margin-bottom: 50px;
  }
}
</style>
